import { MovimientosActuales } from "../../MovimientosActuales";

export const MovimientosActualesHotel = () => {
  return <MovimientosActuales hotel={true} restaurante={false} titulo="Movimientos Actuales - Hotel" />;
};
